import React from 'react'

import { LinkList } from '../../../react4xp/shared/link-list/link-list'

export default (props) => <LinkList {...props} />